/** @jsxImportSource @emotion/react */
import skeletonCss from "./index.css";

export default function Skeleton() {
  return <div css={skeletonCss} />;
}
